import request from '@/services/helpers/request';
import { API_ROUTES } from '@/config';

export const fetchAll = async () => (await request.getInstance()).get(API_ROUTES.profile.fetchAll);
export const remove = async id => (await request.getInstance()).delete(`${API_ROUTES.profile.change}/${id}`);
export const newItem = async data => (await request.getInstance()).post(API_ROUTES.profile.new, data);
export const editItem = async (id, data) => (await request.getInstance()).put(`${API_ROUTES.profile.change}/${id}`, data);
